import event from '~helpers/mixpanel';
import { pageType } from '~constants/pages';

export const trackViewPropertyListPage = () => {
  event('Viewed Property List Page', { 'Current Page Type': pageType.propertyListPage });
};

export const trackClickPropertyListPage = position => {
  event('Clicked Property List Page', {
    'Clicked Position': position,
    'Current Page Type': pageType.propertyListPage,
  });
};

export const trackViewPropertyHomePage = ({ id, name, slug }) => {
  event('Viewed Property Homepage', {
    'Property Name': name,
    'Property Slug': slug,
    'Property Id': id,
    'Current Page Type': pageType.propertyHomePage,
  });
};

export const trackClickPropertyHomePage = (position, { id, name, slug }) => {
  event('Clicked Property Homepage', {
    'Clicked Position': position,
    'Property Name': name,
    'Property Slug': slug,
    'Property Id': id,
    'Current Page Type': pageType.propertyHomePage,
  });
};

export const trackViewPropertyManagePage = ({ id, name, slug }) => {
  event('Viewed Property Management Page', {
    'Property Name': name,
    'Property Slug': slug,
    'Property Id': id,
    'Current Page Type': pageType.propertyManagePage,
  });
};

export const trackViewPropertyTermsPage = ({ id, name, slug }) => {
  event('Viewed Property Term Page', {
    'Property Name': name,
    'Property Slug': slug,
    'Property Id': id,
    'Current Page Type': pageType.propertyTermPage,
  });
};

export const trackViewPropertyContractPage = ({ id, name, slug }) => {
  event('Viewed Property View Contract Page', {
    'Property Name': name,
    'Property Slug': slug,
    'Property Id': id,
    'Current Page Type': pageType.propertyContractPage,
  });
};

export const trackViewPropertyCommissionPage = ({ id, name, slug }) => {
  event('Viewed Property View Commission Page', {
    'Property Name': name,
    'Property Slug': slug,
    'Property Id': id,
    'Current Page Type': pageType.propertyCommissionPage,
  });
};
